import { fromJS } from 'immutable';

import { ApiUrl2, ApiReport, UserToken, PrevilageId } from '../../../helper/HelperAuth'
import {GetReportButtonList, GlobalLoading} from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (page, search, body) => async (dispatch, getState) => {

    dispatch({ type: GlobalLoading, showLoading: true});
    const Authorization = UserToken;
    //
    const urlAccess = ApiUrl2 + 'config-accessmodule-list';
    var paramBodyAccess = {
        "query":{
            "privilege-id":PrevilageId,
        }
    };

    const argumentAccess = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBodyAccess)
    };

    const responseAccess = await doFetch(urlAccess,argumentAccess);
    let dataAccess = fromJS({});
    let array = [];
    let action = 0;
    let show = '';
    if(responseAccess.ok){
        dataAccess = fromJS(await responseAccess.json());
        dataAccess = dataAccess.get('query-result');
    }

    let menuPrev = fromJS(dataAccess).get('data')
    {menuPrev.map((data, i) =>
        array.push({
            'menu-name' :data.get('menu-name'),
            'action-id' : data.get('action-id')
        })

    )}
    for (let i = 0; i < array.length; i++) {
        if (array[i]['menu-name'] === 'Report Button') {
            action = array[i]['action-id']
        }
    }

    var query = {
        'search': body,
        'page':page,
        'page-size':10,
        'order-by':2,
        'order':'DESC',
    };

    if (action == 3 || action == 4) {
        query = {
            "search":body,
            "page":page,
            "page-size":10,
            "order-by":2,
            "order":"DESC",
            "show" : 'all'
        };
    }

    //
    const url = ApiReport + 'report-button-list';
    if(page === undefined){
        page = 1;
    }

    if(search != null){
        search.map((v,k)=>{ 
            if(v !== ''){
                query[k] = v;
            }
        });
    }

    var paramBody = {
        'query': query
    };

    const argument = {  
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBody)
    };

    const response = await doFetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS(await response.json());
        var items = []
        data.get('data').map((item) => {
            items.push({
                'requestid': item.get('requestid'),
                'request-date': item.get('request-date'),
                'status': item.get('status'),
                'client-name': item.get('client-name'),
                'division-name': item.get('division-name'),
                'sender-id':item.get('sender-id'),
                'template-id':item.get('template-id'),
                'start-date':item.get('request-data').get('start-date'),
                'end-date':item.get('request-data').get('end-date'),
                'request-data':item.get('request-data'),
                'reportFormat':item.get('report-format'),
                'reportFormatName':item.get('report-format-name'),
                'reportLinkSummary':item.get('report-link-summary'),
                'reportLinkDetail':item.get('report-link-detail'),
                'file-name':item.get('file-name'),
                'part':item.get('part'),
            })
        })

        var temp = {
            'row-count': data.get('row-count'),
            'page-size': data.get('page-size'),
            'page-count': data.get('page-count'),
            'order-by': data.get('order-by'),
            'page': data.get('page'),
            'order': data.get('order'),
            'data': items
        }

    }
    
    dispatch({ type: GlobalLoading, showLoading: false});
    dispatch({ type: GetReportButtonList, data: fromJS(temp) });
};